import React from 'react';
import './login-head.styles.scss';
import Logo from '../../assets/images/png/logo.png';

function LoginHead() {
    return (
        <div className="login-head">
            <div className="login-head__ribbon" />
            <div className="login-head__logo">
                <div className="login-head__logo__site-name">
                    <img src={Logo} alt="Logo" />
                </div>
                <div className="login-head__logo__site-description">
                    <span>People Innovation Excellence</span>
                </div>
            </div>
        </div>
    );
}

export default LoginHead;
